<template>
  <div
    class="TobBar"
    :style="{ backgroundImage: `url(${bgImg})`, backgroundSize: `contain` }"
  >
    <div class="left"></div>
    <div class="center"><slot name="center"></slot></div>
    <div class="right"><slot name="right"></slot></div>
  </div>
</template>

<script>
export default {
  name: "TobBar",
  components: {},
  props: ["bgImg"],
  data() {
    return {};
  },
  watch: {},
  computed: {},
  created() {},
  mounted() {},
  methods: {},
};
</script>

<style lang="less" scoped>
.TobBar {
  width: 100%;
  height: 96px;
  padding: 0 16px;
  display: flex;
  .left,
  .right,
  .center {
    flex: 1;
  }
}
</style>

